import React from 'react';

import { TextValue, TextValueProps } from '@/components/shared/components/TextValue';

import { useTranslation } from '../hooks/useTranslation';

interface TextProps extends TextValueProps {
  tId: string;
  lowerCased?: boolean;
  upperCased?: boolean;
  linkCallbacks?: { (): void }[];
  linkStyle?: React.CSSProperties;
  capitalized?: boolean;
  trueResult?: boolean;
  originalTextId?: boolean;
  strong?: boolean;
}

export const Text = (props: TextProps) => {
  const { tId } = props;
  const { getTextIdTranslation } = useTranslation();
  const textId = tId;
  const translation = textId ? getTextIdTranslation(textId) : null;
  const result = TextValue({
    translation: translation || undefined,
    linkStyle: { color: 'inherit', fontWeight: '700' },
    ...props,
    tId: textId,
  });

  return result || <></>;
};
